import { Skeleton, Table } from '@/components';
import type { FC } from 'react';

const columns = [
  { title: '名前', dataIndex: 'name', key: 'name' },
  { title: 'Eメール', dataIndex: 'email', key: 'email' },
  { title: '組織名', dataIndex: 'organization', key: 'organization' },
];

const generateSkeletonData = (count: number) => {
  return Array.from({ length: count }, (_, index) => ({
    key: index,
    name: <Skeleton.Input active size="small" />,
    email: <Skeleton.Input active />,
    organization: <Skeleton.Input active size="small" />,
  }));
};

export const UsersTableSkeleton: FC = () => {
  return (
    <Table
      columns={columns}
      dataSource={generateSkeletonData(10)}
      pagination={{
        total: 38,
        current: 6,
        pageSize: 10,
        showSizeChanger: false,
      }}
    />
  );
};
